/*! @azure/msal-browser v3.28.1 2025-01-14 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const userSwitch = "user_switch";

export { contentError, userSwitch };
//# sourceMappingURL=NativeAuthErrorCodes.mjs.map
